import PropTypes from 'prop-types'

import { formatTimeRange } from '@/utils/date/format-time-range'

import { formatPermissions, emptyOptionText } from '../../utils'

const Permission = ({ visitor, timezone }) => {
  if (!visitor) {
    return emptyOptionText
  }

  const permission = formatPermissions(visitor)
  const permissionTime = formatTimeRange(visitor.startTime, visitor.endTime, timezone)

  return (
    <p>
      {permission}, {permissionTime}
    </p>
  )
}

Permission.propTypes = {
  visitor: PropTypes.object,
  timezone: PropTypes.string,
}

export default Permission
